import {Component, OnInit} from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import {NavigationEnd, Router} from '@angular/router';
import {environment} from '../environments/environment';

declare let ga: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(private router: Router) {
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        ga('create', environment.GOOGLE_ANALYTICS_TRACKING_ID, 'auto', 'visio');
        ga('visio.set', 'page', event.urlAfterRedirects);
        ga('visio.send', 'pageview');
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts